import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/leadActivitySagas";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { useDateFormat } from "../../../../hooks/useDateFormat";

const DatePicker = ({ startDate, endDate, zIndex, index = null, isLeadSelected }) => {
  const dispatch = useDispatch();
  const { calendarEndDate, calendarStartDate, leadCalendarStartDate } = useSelector(
    (state) => state.leadActivity.currentUser
  );
  const dateFormat = useDateFormat();
  const minDate = isLeadSelected ? leadCalendarStartDate : calendarStartDate;

  const handleUpdateDates = (startDate, endDate) => {
    const payload = {
      key: "selectedRequestDates",
      data: { startDate, endDate }
    };
    if (index == null) {
      return dispatch(actionCreators.updateMainFilter(payload));
    }

    dispatch(actionCreators.updateFilterByIndex({ ...payload, index }));
  };

  return (
    <div className="date-select-box select-box multi" style={{ zIndex }}>
      <p className="offers-title">Date</p>
      <ReactDatePicker
        displayFormat={dateFormat}
        startDate={startDate}
        endDate={endDate}
        calendarEndDate={calendarEndDate}
        isRangePicker
        minDate={minDate}
        updateDates={handleUpdateDates}
      />
    </div>
  );
};

export default DatePicker;
